// Internal modules
import styled from '@emotion/styled';

const OptionalAccountFieldset = styled.fieldset`
  margin-top: 6px;
  padding-left: 35px;

  > div {
    margin-bottom: ${props => (props.isSignup ? '12px' : '0')};
  }
`;

const OptionalAccountOption = styled.div`
  margin-bottom: 18px;

  &:last-of-type {
    margin-bottom: 32px;
  }
`;

const SepaContainer = styled.div`
  padding-top: 8px;
`;

export { OptionalAccountFieldset, OptionalAccountOption, SepaContainer };
